import React, { useContext } from "react";
import AssuranceContext from "../../context/index";
import withStyles from "@material-ui/core/styles/withStyles";
import ReactTooltip from "react-tooltip";
import { Help } from "@material-ui/icons";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./dashboardStyles";

function Cards({
  classes: {
    performanceCards,
    performanceCardsBox,
    spacing,
  },
}) {
  const { state: { cards }, dispatch } = useContext(AssuranceContext);

  return (
    <Box className={performanceCardsBox}>
      {cards.map((item, index) => {
        return (
          item.visible && (
            <Box key={index} className={performanceCards}>
              <Box className={`${spacing} ${item.class}`}>
                <Typography variant={"h4"}>
                  {<b>{item.count >= 10 ? item.count : `0${item.count}`}</b>}
                </Typography>
              </Box>
              <Box className={spacing}>
                <Typography
                  variant={"body1"}
                  data-tip={item.tooltip}
                  className={`${item.class}1`}
                >
                  {item.title}{" "}
                  {item.tooltip && (
                    <>
                      <Help style={{ height: "16px" }} /> <ReactTooltip html={true} />
                    </>
                  )}
                </Typography>
              </Box>
            </Box>
          )
        );
      })}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(Cards);
